import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class DocumentShareApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'documentShare'
  }

}